export type LoanSimulatorConfigItem<InputType> = {
  min: InputType
  max: InputType
  step: number
  legend: {
    min: string
    max: string
  }
}

export type LoanSimulatorConfig = {
  moneyAmount: LoanSimulatorConfigItem<number>
  installments: LoanSimulatorConfigItem<PossibleMonthlyInstallments>
}

export type PossibleMonthlyInstallments = keyof typeof LOAN_TAX_BY_INSTALLMENTS

export const LOAN_TAX_BY_INSTALLMENTS = {
  6: 0.1575,
  12: 0.0594,
  24: 0.038,
  36: 0.0346,
  48: 0.033,
}

export const LOAN_FORM_CONFIG: LoanSimulatorConfig = {
  moneyAmount: {
    min: 150,
    max: 30000,
    step: 250,

    legend: {
      min: 'R$ 150',
      max: 'R$ 30.000',
    },
  },
  installments: {
    min: 6 as PossibleMonthlyInstallments,
    max: 48 as PossibleMonthlyInstallments,
    legend: {
      min: '6 meses',
      max: '48 meses',
    },
    step: 12,
  },
}

export const BASE_LOAN_URL =
  'https://www.serasa.com.br/entrar?redirectUrl=%2Farea-cliente%2Fsolucoes%2Farea-credito%2Femprestimo'
